module.exports = __webpack_public_path__ + "img/recette-edit-2ingredient.8372f279.png";